module.exports = __webpack_public_path__ + "img/banner.2be8456a.png";